import { Component } from '@angular/core';
import { Router, NavigationEnd} from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { filter } from 'rxjs';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
})
export class TermsConditionsComponent {

  /** Aba visivel: os termos da plataforma web ou os do aplicativo de coleta. */
  aba: 'plataforma' | 'app' = 'plataforma';


  constructor(private router: Router, private viewportScroller: ViewportScroller) { }

  ngOnInit() {
    // scrollar para o topo da página na mudança de rota
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.viewportScroller.scrollToPosition([0, 0]);
    });
  }
}
